export const JPY = 'JPY';
export const COP = 'COP';
export const SGD = 'SGD';
export const EUR = 'EUR';
export const GBP = 'GBP';
export const USD = 'USD';
export const AUD = 'AUD';
export const CurrencyCodes = [JPY, COP, SGD, EUR, GBP, USD, AUD];
export const zeroDigitPrecisionCurrencyCodes = [JPY, COP];